module.exports = __webpack_public_path__ + "img/[流泪].e60e2727.svg";